// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"a16c2835","740":"a88b7792","995":"42ce2347"}[chunkId] + ".chunk.css";
};